import React, { useEffect, useState } from 'react'

const UpdateFair = () => {
  const local = window.location
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fair = local.pathname.replace('/ferias-cms/actualizar-feria/', '')
    setLoading(true)
    fetch(`https://apinewplanificador.holaislascanarias.com/api/v1/config-planner/fair/${fair}`)
      .then(res => res.json())
      .then(data => {
        console.log(data)
        fetch(`https://internalappferiasbackend.holaislascanarias.com/api/v1/config-planner/${data.id}`, {
          method: "PATCH",
          headers: {
              "Content-Type": "application/json",
              "accept": "*/*"
          },
          body: JSON.stringify({
              "config": data.config
          })
        }).then(res => {
          setLoading(false)
        })
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      })
  }, [])

    return (
        <div>
        { loading ? (
          <div className="loading">
            <div className="loading__content">
              <div className="loading__content__title">Cargando...</div>
              <div className="loading__content__loader"></div>
            </div>
          </div>
        ) : (
          <div className="loading">
            <div className="loading__content">
              <div className="loading__content__title">Feria actualizada</div>
              <div className="loading__content__loader"></div>
            </div>
          </div>
        )}
        </div>
    )
}

export default UpdateFair
